import { Injectable } from '@angular/core';

export const TEMPLATE_BRAND_NAME = '%BRAND_NAME%';

enum WhitelabelContext {
  PROC_CERT = 'PROC_CERT',
  MTCT = 'MTCT',
}
// const DEFAULT_WHITELABEL_CONTEXT = WhitelabelContext.CALCULATING_CATS;
const DEFAULT_WHITELABEL_CONTEXT = WhitelabelContext.PROC_CERT;

const contextData = {

  PROC_CERT : {
    homepageRoute: '/',
    brandName: 'Mathematics Proficiency Test',
    logo: '',
    siteFlags: {
    },
    siteText: {
      
    }
  },
  
}

@Injectable({
  providedIn: 'root'
})
export class WhitelabelService {

  context:WhitelabelContext;
  currentHomepageRoute:string;
  currentBrandName:string;
  currentLogo:string;
  
  constructor() {
    let host:string = window.location.host;
    switch (host){
      // case 'calculatingcats.com':
      //   this.context = WhitelabelContext.CALCULATING_CATS;
      //   break;
      default: 
        const defaultWhitelabel = localStorage.getItem('defaultWhitelabel');
        if (defaultWhitelabel && contextData[defaultWhitelabel]){
          this.context = <WhitelabelContext>defaultWhitelabel;
        }
        else{
          this.context = DEFAULT_WHITELABEL_CONTEXT;
        }
        break;
    }
    let currentContextData = contextData[this.context];
    if (!currentContextData){
      currentContextData = contextData[DEFAULT_WHITELABEL_CONTEXT]
    }
    this.currentHomepageRoute = currentContextData.homepageRoute;
    this.currentBrandName = currentContextData.brandName;
    this.currentLogo = currentContextData.logo;
    this.ensureDefaultContext();  
  }

  ensureDefaultContext(){
    if (!contextData[this.context]){
      console.error('using undefined context');
    }
    if (!contextData[this.context].siteText){
      contextData[this.context].siteText = {};
    }
    if (!contextData[this.context].siteFlags){
      contextData[this.context].siteFlags = {};
    }
    const siteText = contextData[this.context].siteText;
    if (!siteText['SITE_LINK']){
      siteText['SITE_LINK'] = window.location.host;
    }
  }

  onReady( callback ){
    callback(); // need to delay this if config is loaded over a file
  }

  updateTemplateContent(str:string){
    if (str){
      return str.split(TEMPLATE_BRAND_NAME).join(this.currentBrandName);
    }
    return str;
  }

  getSiteFlag(slug:string){
    return contextData[this.context].siteFlags[slug];
  }
  
  getDefaultCurriculumId(){
    return contextData[this.context].defaultCurriculumId
  }

  getSiteText(slug:string, defaultText:string=''){
    return contextData[this.context].siteText[slug] || defaultText;
  }

  getHomepageRoute(){
    return this.currentHomepageRoute
  }
}
